import React from 'react';
import { Link } from "react-router-dom";
import back from '../../utils/images/back.png'
import { Filter } from '../Common/Filter';

type Props = {
  ViolationDetailStatus:boolean
  timeFilterChanged: (event: any, type: string) => void,
  violationsCountChanged: (event: any) => void,
  viewSelectedViolation:() => void,
  ViolationTypeCheckingAll:() => void,
  ViolationTypeCheckingSeatBelt:() => void,
  ViolationTypeCheckingCellphone:() => void,
  ViolationTypeCheckingQueneJumping:() => void,
  ViolationTypeCheckingRedLight:() => void,
  ViolationTypeCheckingTrespassZebra:() => void,
  ViolationTypeCheckingWrongTurn:() => void,
  ViolationTypeCheckingWrongWay:() => void,
  ViolationTypeCheckingSpeed:() => void,
  ViolationTypeCheckingSpotSpeed:() => void,
  ViolationTypeStatusAll:boolean,
  ViolationTypeStatusSeatBelt: boolean,
  ViolationTypeStatusCellphone: boolean,
  ViolationTypeStatusQueneJumping: boolean,
  ViolationTypeStatusRedLight: boolean,
  ViolationTypeStatusTrespassZebra: boolean,
  ViolationTypeStatusWrongTurn: boolean,
  ViolationTypeStatusWrongWay: boolean,
  ViolationTypeStatusSpeed: boolean,
  ViolationTypeStatusSpotSpeed: boolean,
};

const Data = (
  {
    timeFilterChanged,
    violationsCountChanged,
    ViolationDetailStatus,
    viewSelectedViolation,
    ViolationTypeCheckingAll,
    ViolationTypeCheckingSeatBelt,
    ViolationTypeCheckingCellphone,
    ViolationTypeCheckingQueneJumping,
    ViolationTypeCheckingRedLight,
    ViolationTypeCheckingTrespassZebra,
    ViolationTypeCheckingWrongTurn,
    ViolationTypeCheckingWrongWay,
    ViolationTypeCheckingSpeed,
    ViolationTypeCheckingSpotSpeed,
    ViolationTypeStatusAll,
    ViolationTypeStatusSeatBelt,
    ViolationTypeStatusCellphone,
    ViolationTypeStatusQueneJumping,
    ViolationTypeStatusRedLight,
    ViolationTypeStatusTrespassZebra,
    ViolationTypeStatusWrongTurn,
    ViolationTypeStatusWrongWay,
    ViolationTypeStatusSpeed,
    ViolationTypeStatusSpotSpeed,
  }: Props) => (
  <div>
     <div className="ViolationHistoryHeader">
     <Link to={"/selectcamera"}> <h6 className = "historyheader">  <img src={back}/> Back</h6></Link>
     <Filter
         ViolationTypeCheckingAll={ViolationTypeCheckingAll}
         ViolationTypeCheckingSeatBelt={ViolationTypeCheckingSeatBelt}
         ViolationTypeCheckingCellphone={ViolationTypeCheckingCellphone}
         ViolationTypeCheckingQueneJumping={ViolationTypeCheckingQueneJumping}
         ViolationTypeCheckingTrespassZebra={ViolationTypeCheckingTrespassZebra}
         ViolationTypeCheckingRedLight={ViolationTypeCheckingRedLight}
         ViolationTypeCheckingWrongTurn={ViolationTypeCheckingWrongTurn}
         ViolationTypeCheckingWrongWay={ViolationTypeCheckingWrongWay}
         ViolationTypeCheckingSpeed={ViolationTypeCheckingSpeed}
         ViolationTypeCheckingSpotSpeed={ViolationTypeCheckingSpotSpeed}
         ViolationTypeStatusAll={ViolationTypeStatusAll}
         ViolationTypeStatusSeatBelt={ViolationTypeStatusSeatBelt}
         ViolationTypeStatusCellphone={ViolationTypeStatusCellphone}
         ViolationTypeStatusQueneJumping={ViolationTypeStatusQueneJumping}
         ViolationTypeStatusRedLight={ViolationTypeStatusRedLight}
         ViolationTypeStatusTrespassZebra={ViolationTypeStatusTrespassZebra}
         ViolationTypeStatusWrongTurn={ViolationTypeStatusWrongTurn}
         ViolationTypeStatusWrongWay={ViolationTypeStatusWrongWay}
         ViolationTypeStatusSpeed={ViolationTypeStatusSpeed}
         ViolationTypeStatusSpotSpeed={ViolationTypeStatusSpotSpeed}
         timeFilterChanged={timeFilterChanged}
         violationsCountChanged={violationsCountChanged}

     />
      </div>
  </div>
);

export default Data;


// WEBPACK FOOTER //
// ./src/components/ViolationsHistory/Data.tsx